import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
import Vue from 'vue';
import Router from 'vue-router';
import { interopDefault } from './utils';

var _5a9a280f = function _5a9a280f() {
  return interopDefault(import('../pages/monitoring.vue'
  /* webpackChunkName: "pages/monitoring" */
  ));
};

var _c13e5eda = function _c13e5eda() {
  return interopDefault(import('../pages/redirect_url.vue'
  /* webpackChunkName: "pages/redirect_url" */
  ));
};

var _b544447e = function _b544447e() {
  return interopDefault(import('../pages/tools/grid.vue'
  /* webpackChunkName: "pages/tools/grid" */
  ));
};

var _9259d8e2 = function _9259d8e2() {
  return interopDefault(import('../pages/_market/_language/index.vue'
  /* webpackChunkName: "pages/_market/_language/index" */
  ));
};

var _799bf836 = function _799bf836() {
  return interopDefault(import('../pages/_market/_language/cart/index.vue'
  /* webpackChunkName: "pages/_market/_language/cart/index" */
  ));
};

var _1b405717 = function _1b405717() {
  return interopDefault(import('../pages/_market/_language/help/index.vue'
  /* webpackChunkName: "pages/_market/_language/help/index" */
  ));
};

var _679daeae = function _679daeae() {
  return interopDefault(import('../pages/_market/_language/login/index.vue'
  /* webpackChunkName: "pages/_market/_language/login/index" */
  ));
};

var _722e1c96 = function _722e1c96() {
  return interopDefault(import('../pages/_market/_language/sitemap/index.vue'
  /* webpackChunkName: "pages/_market/_language/sitemap/index" */
  ));
};

var _6876aeaa = function _6876aeaa() {
  return interopDefault(import('../pages/_market/_language/store-locator/index.vue'
  /* webpackChunkName: "pages/_market/_language/store-locator/index" */
  ));
};

var _dac861be = function _dac861be() {
  return interopDefault(import('../pages/_market/_language/user/index.vue'
  /* webpackChunkName: "pages/_market/_language/user/index" */
  ));
};

var _4feef6c5 = function _4feef6c5() {
  return interopDefault(import('../pages/_market/_language/help/confirm.vue'
  /* webpackChunkName: "pages/_market/_language/help/confirm" */
  ));
};

var _33fc8531 = function _33fc8531() {
  return interopDefault(import('../pages/_market/_language/help/deliveryConfirm.vue'
  /* webpackChunkName: "pages/_market/_language/help/deliveryConfirm" */
  ));
};

var _1d366704 = function _1d366704() {
  return interopDefault(import('../pages/_market/_language/poc/grid.vue'
  /* webpackChunkName: "pages/_market/_language/poc/grid" */
  ));
};

var _5cbcacfc = function _5cbcacfc() {
  return interopDefault(import('../pages/_market/_language/s/catalogue-luminaires.vue'
  /* webpackChunkName: "pages/_market/_language/s/catalogue-luminaires" */
  ));
};

var _13391162 = function _13391162() {
  return interopDefault(import('../pages/_market/_language/s/home-by-me.vue'
  /* webpackChunkName: "pages/_market/_language/s/home-by-me" */
  ));
};

var _603b5c8a = function _603b5c8a() {
  return interopDefault(import('../pages/_market/_language/s/lighting.vue'
  /* webpackChunkName: "pages/_market/_language/s/lighting" */
  ));
};

var _331ebb8c = function _331ebb8c() {
  return interopDefault(import('../pages/_market/_language/s/sustainable-development.vue'
  /* webpackChunkName: "pages/_market/_language/s/sustainable-development" */
  ));
};

var _b1232472 = function _b1232472() {
  return interopDefault(import('../pages/_market/_language/user/gift-cards.vue'
  /* webpackChunkName: "pages/_market/_language/user/gift-cards" */
  ));
};

var _760ed1ae = function _760ed1ae() {
  return interopDefault(import('../pages/_market/_language/user/orders/index.vue'
  /* webpackChunkName: "pages/_market/_language/user/orders/index" */
  ));
};

var _545c9ab8 = function _545c9ab8() {
  return interopDefault(import('../pages/_market/_language/user/profile.vue'
  /* webpackChunkName: "pages/_market/_language/user/profile" */
  ));
};

var _3848373b = function _3848373b() {
  return interopDefault(import('../pages/_market/_language/user/profile/index.vue'
  /* webpackChunkName: "pages/_market/_language/user/profile/index" */
  ));
};

var _6a825cea = function _6a825cea() {
  return interopDefault(import('../pages/_market/_language/user/profile/addresses.vue'
  /* webpackChunkName: "pages/_market/_language/user/profile/addresses" */
  ));
};

var _1a54b6fe = function _1a54b6fe() {
  return interopDefault(import('../pages/_market/_language/user/profile/alerts.vue'
  /* webpackChunkName: "pages/_market/_language/user/profile/alerts" */
  ));
};

var _1c391919 = function _1c391919() {
  return interopDefault(import('../pages/_market/_language/user/profile/FormAddress.vue'
  /* webpackChunkName: "pages/_market/_language/user/profile/FormAddress" */
  ));
};

var _a651d57c = function _a651d57c() {
  return interopDefault(import('../pages/_market/_language/user/profile/password.vue'
  /* webpackChunkName: "pages/_market/_language/user/profile/password" */
  ));
};

var _4175fc74 = function _4175fc74() {
  return interopDefault(import('../pages/_market/_language/user/wishlist.vue'
  /* webpackChunkName: "pages/_market/_language/user/wishlist" */
  ));
};

var _77f6753e = function _77f6753e() {
  return interopDefault(import('../pages/_market/_language/configurator/product/_model.vue'
  /* webpackChunkName: "pages/_market/_language/configurator/product/_model" */
  ));
};

var _a39137e8 = function _a39137e8() {
  return interopDefault(import('../pages/_market/_language/e/magazine/_slug.vue'
  /* webpackChunkName: "pages/_market/_language/e/magazine/_slug" */
  ));
};

var _01fa6739 = function _01fa6739() {
  return interopDefault(import('../pages/_market/_language/help/contact/_form.vue'
  /* webpackChunkName: "pages/_market/_language/help/contact/_form" */
  ));
};

var _8a8f232e = function _8a8f232e() {
  return interopDefault(import('../pages/_market/_language/help/faq/_answer.vue'
  /* webpackChunkName: "pages/_market/_language/help/faq/_answer" */
  ));
};

var _10c8d34f = function _10c8d34f() {
  return interopDefault(import('../pages/_market/_language/help/return/_form.vue'
  /* webpackChunkName: "pages/_market/_language/help/return/_form" */
  ));
};

var _13185df6 = function _13185df6() {
  return interopDefault(import('../pages/_market/_language/user/orders/_reference.vue'
  /* webpackChunkName: "pages/_market/_language/user/orders/_reference" */
  ));
};

var _7a92bd60 = function _7a92bd60() {
  return interopDefault(import('../pages/_market/_language/c/_alias.vue'
  /* webpackChunkName: "pages/_market/_language/c/_alias" */
  ));
};

var _f920697e = function _f920697e() {
  return interopDefault(import('../pages/_market/_language/configurator/_model.vue'
  /* webpackChunkName: "pages/_market/_language/configurator/_model" */
  ));
};

var _1a5fe457 = function _1a5fe457() {
  return interopDefault(import('../pages/_market/_language/inspirations/_slug.vue'
  /* webpackChunkName: "pages/_market/_language/inspirations/_slug" */
  ));
};

var _08eeb628 = function _08eeb628() {
  return interopDefault(import('../pages/_market/_language/p/_slug.vue'
  /* webpackChunkName: "pages/_market/_language/p/_slug" */
  ));
};

var _3d95411b = function _3d95411b() {
  return interopDefault(import('../pages/_market/_language/q/_keyword.vue'
  /* webpackChunkName: "pages/_market/_language/q/_keyword" */
  ));
};

var _50a60ec9 = function _50a60ec9() {
  return interopDefault(import('../pages/_market/_language/e/_alias/_slug.vue'
  /* webpackChunkName: "pages/_market/_language/e/_alias/_slug" */
  ));
};

var _d3e9a946 = function _d3e9a946() {
  return interopDefault(import('../pages/_market/_language/index.vue'
  /* webpackChunkName: "" */
  ));
};

var _63bd6b49 = function _63bd6b49() {
  return interopDefault(import('../pages/_market/_language/inspirations/_slug.vue'
  /* webpackChunkName: "" */
  ));
};

var _52a6eaad = function _52a6eaad() {
  return interopDefault(import('../pages/_market/_language/s/lighting.vue'
  /* webpackChunkName: "" */
  ));
};

var _4b34c87e = function _4b34c87e() {
  return interopDefault(import('../pages/_market/_language/s/home-by-me.vue'
  /* webpackChunkName: "" */
  ));
};

var _3cb0debb = function _3cb0debb() {
  return interopDefault(import('../pages/_market/_language/e/_alias/_slug.vue'
  /* webpackChunkName: "" */
  ));
};

var _4aca05f8 = function _4aca05f8() {
  return interopDefault(import('../pages/_market/_language/store-locator/index.vue'
  /* webpackChunkName: "" */
  ));
};

Vue.use(Router);

if (process.client) {
  if ('scrollRestoration' in window.history) {
    window.history.scrollRestoration = 'manual'; // reset scrollRestoration to auto when leaving page, allowing page reload
    // and back-navigation from other pages to use the browser to restore the
    // scrolling position.

    window.addEventListener('beforeunload', function () {
      window.history.scrollRestoration = 'auto';
    }); // Setting scrollRestoration to manual again when returning to this page.

    window.addEventListener('load', function () {
      window.history.scrollRestoration = 'manual';
    });
  }
}

var scrollBehavior = function scrollBehavior(to, from, savedPosition) {
  // if the returned position is falsy or an empty object,
  // will retain current scroll position.
  var position = false; // if no children detected and scrollToTop is not explicitly disabled

  if (to.matched.length < 2 && to.matched.every(function (r) {
    return r.components.default.options.scrollToTop !== false;
  })) {
    // scroll to the top of the page
    position = {
      x: 0,
      y: 0
    };
  } else if (to.matched.some(function (r) {
    return r.components.default.options.scrollToTop;
  })) {
    // if one of the children has scrollToTop option set to true
    position = {
      x: 0,
      y: 0
    };
  } // savedPosition is only available for popstate navigations (back button)


  if (savedPosition) {
    position = savedPosition;
  }

  return new Promise(function (resolve) {
    // wait for the out transition to complete (if necessary)
    window.$nuxt.$once('triggerScroll', function () {
      // coords will be used if no selector is provided,
      // or if the selector didn't match any element.
      if (to.hash) {
        var hash = to.hash; // CSS.escape() is not supported with IE and Edge.

        if (typeof window.CSS !== 'undefined' && typeof window.CSS.escape !== 'undefined') {
          hash = '#' + window.CSS.escape(hash.substr(1));
        }

        try {
          if (document.querySelector(hash)) {
            // scroll to anchor by returning the selector
            position = {
              selector: hash
            };
          }
        } catch (e) {
          console.warn('Failed to save scroll position. Please add CSS.escape() polyfill (https://github.com/mathiasbynens/CSS.escape).');
        }
      }

      resolve(position);
    });
  });
};

export function createRouter() {
  return new Router({
    mode: 'history',
    base: decodeURI('/'),
    linkActiveClass: 'nuxt-link-active',
    linkExactActiveClass: 'nuxt-link-exact-active',
    scrollBehavior: scrollBehavior,
    routes: [{
      path: "/monitoring",
      component: _5a9a280f,
      name: "monitoring"
    }, {
      path: "/redirect_url",
      component: _c13e5eda,
      name: "redirect_url"
    }, {
      path: "/tools/grid",
      component: _b544447e,
      name: "tools-grid"
    }, {
      path: "/:market/:language",
      component: _9259d8e2,
      name: "market-language"
    }, {
      path: "/:market/:language/cart",
      component: _799bf836,
      name: "market-language-cart"
    }, {
      path: "/:market/:language/help",
      component: _1b405717,
      name: "market-language-help"
    }, {
      path: "/:market/:language/login",
      component: _679daeae,
      name: "market-language-login"
    }, {
      path: "/:market/:language/sitemap",
      component: _722e1c96,
      name: "market-language-sitemap"
    }, {
      path: "/:market/:language/store-locator",
      component: _6876aeaa,
      name: "market-language-store-locator"
    }, {
      path: "/:market/:language/user",
      component: _dac861be,
      name: "market-language-user"
    }, {
      path: "/:market/:language/help/confirm",
      component: _4feef6c5,
      name: "market-language-help-confirm"
    }, {
      path: "/:market/:language/help/deliveryConfirm",
      component: _33fc8531,
      name: "market-language-help-deliveryConfirm"
    }, {
      path: "/:market/:language/poc/grid",
      component: _1d366704,
      name: "market-language-poc-grid"
    }, {
      path: "/:market/:language/s/catalogue-luminaires",
      component: _5cbcacfc,
      name: "market-language-s-catalogue-luminaires"
    }, {
      path: "/:market/:language/s/home-by-me",
      component: _13391162,
      name: "market-language-s-home-by-me"
    }, {
      path: "/:market/:language/s/lighting",
      component: _603b5c8a,
      name: "market-language-s-lighting"
    }, {
      path: "/:market/:language/s/sustainable-development",
      component: _331ebb8c,
      name: "market-language-s-sustainable-development"
    }, {
      path: "/:market/:language/user/gift-cards",
      component: _b1232472,
      name: "market-language-user-gift-cards"
    }, {
      path: "/:market/:language/user/orders",
      component: _760ed1ae,
      name: "market-language-user-orders"
    }, {
      path: "/:market/:language/user/profile",
      component: _545c9ab8,
      children: [{
        path: "",
        component: _3848373b,
        name: "market-language-user-profile"
      }, {
        path: "addresses",
        component: _6a825cea,
        name: "market-language-user-profile-addresses"
      }, {
        path: "alerts",
        component: _1a54b6fe,
        name: "market-language-user-profile-alerts"
      }, {
        path: "FormAddress",
        component: _1c391919,
        name: "market-language-user-profile-FormAddress"
      }, {
        path: "password",
        component: _a651d57c,
        name: "market-language-user-profile-password"
      }]
    }, {
      path: "/:market/:language/user/wishlist",
      component: _4175fc74,
      name: "market-language-user-wishlist"
    }, {
      path: "/:market/:language/configurator/product/:model?",
      component: _77f6753e,
      name: "market-language-configurator-product-model"
    }, {
      path: "/:market/:language/e/magazine/:slug?",
      component: _a39137e8,
      name: "market-language-e-magazine-slug"
    }, {
      path: "/:market/:language/help/contact/:form?",
      component: _01fa6739,
      name: "market-language-help-contact-form"
    }, {
      path: "/:market/:language/help/faq/:answer?",
      component: _8a8f232e,
      name: "market-language-help-faq-answer"
    }, {
      path: "/:market/:language/help/return/:form?",
      component: _10c8d34f,
      name: "market-language-help-return-form"
    }, {
      path: "/:market/:language/user/orders/:reference?",
      component: _13185df6,
      name: "market-language-user-orders-reference"
    }, {
      path: "/:market/:language/c/:alias?",
      component: _7a92bd60,
      name: "market-language-c-alias"
    }, {
      path: "/:market/:language/configurator/:model?",
      component: _f920697e,
      name: "market-language-configurator-model"
    }, {
      path: "/:market/:language/inspirations/:slug?",
      component: _1a5fe457,
      name: "market-language-inspirations-slug"
    }, {
      path: "/:market/:language/p/:slug?",
      component: _08eeb628,
      name: "market-language-p-slug"
    }, {
      path: "/:market/:language/q/:keyword?",
      component: _3d95411b,
      name: "market-language-q-keyword"
    }, {
      path: "/:market/:language/e/:alias?/:slug?",
      component: _50a60ec9,
      name: "market-language-e-alias-slug"
    }, {
      path: "/",
      component: _d3e9a946,
      name: "market-language-home-fr"
    }, {
      path: "/:market/:language/inspirations*",
      component: _63bd6b49,
      name: "market-language-inspirations-fr"
    }, {
      path: "/:market/:language/inspirationen*",
      component: _63bd6b49,
      name: "market-language-inspirations-de"
    }, {
      path: "/:market/:language/ispirazione*",
      component: _63bd6b49,
      name: "market-language-inspirations-it"
    }, {
      path: "/:market/:language/inspiration*",
      component: _63bd6b49,
      name: "market-language-inspirations-en"
    }, {
      path: "/:market/:language/inspiration*",
      component: _63bd6b49,
      name: "market-language-inspirations-pt"
    }, {
      path: "/:market/:language/inspiracion*",
      component: _63bd6b49,
      name: "market-language-inspirations-es"
    }, {
      path: "/:market/:language/s/inspiratie*",
      component: _63bd6b49,
      name: "market-language-inspirations-nl"
    }, {
      path: "/:market/:language/s/luminaires*",
      component: _52a6eaad,
      name: "market-language-lighting-fr"
    }, {
      path: "/:market/:language/s/leuchten*",
      component: _52a6eaad,
      name: "market-language-lighting-de"
    }, {
      path: "/:market/:language/s/illuminazioni*",
      component: _52a6eaad,
      name: "market-language-lighting-it"
    }, {
      path: "/:market/:language/s/lighting*",
      component: _52a6eaad,
      name: "market-language-lighting-en"
    }, {
      path: "/:market/:language/s/lighting*",
      component: _52a6eaad,
      name: "market-language-lighting-pt"
    }, {
      path: "/:market/:language/s/lamparas*",
      component: _52a6eaad,
      name: "market-language-lighting-es"
    }, {
      path: "/:market/:language/s/verlichting*",
      component: _52a6eaad,
      name: "market-language-lighting-nl"
    }, {
      path: "/:market/:language/s/atelier-deco*",
      component: _4b34c87e,
      name: "market-language-home-by-me-fr"
    }, {
      path: "/:market/:language/s/atelier-arredo*",
      component: _4b34c87e,
      name: "market-language-home-by-me-it"
    }, {
      path: "/:market/:language/s/taller-de-decoracion*",
      component: _4b34c87e,
      name: "market-language-home-by-me-es"
    }, {
      path: "/:market/:language/s/dekowerkstatt*",
      component: _4b34c87e,
      name: "market-language-home-by-me-de"
    }, {
      path: "/:market/:language/s/decor-workshop*",
      component: _4b34c87e,
      name: "market-language-home-by-me-en"
    }, {
      path: "/:market/:language/:alias/:slug",
      component: _3cb0debb,
      name: "market-language-editorial"
    }, {
      path: "/:market/:language/magasins/",
      component: _4aca05f8,
      name: "store-locator"
    }],
    fallback: false
  });
}